import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
let personDom = class personDom extends Vue {
    // highlight:string = highlight;
    status;
    personId;
    // @Prop() status!: string;
    // @Prop() personId!: string;
    handleClick(e) {
        // e.preventDefault();
        e.stopPropagation();
        // this.dialogVisible = true;
        this.$emit('onClickPerson', this.personId);
    }
};
personDom = __decorate([
    Component({
        name: 'person',
    })
], personDom);
export default personDom;
